import Vue from 'vue'

const GkCheckBeforeDateDirective = Vue.directive('gkCheckBeforeDate', {
  bind(el, binding, vnode) {
    const ctx = vnode.context
    const opts = binding.value || {}
    if (opts.enabled === false) return

    // Validate callback if provided
    if (opts.callback && !isFn(opts.callback)) {
      throw 'callback is not a function.'
    }

    // cutoff can be a string OR a function returning a string
    const getCutoff = isFn(opts.cutoff)
      ? opts.cutoff.bind(ctx)
      : () => opts.cutoff

    // Determine how we read the watched value
    let getter = null

    if (isFn(opts.getValue)) {
      getter = opts.getValue.bind(ctx)
    } else if (typeof opts.modelPath === 'string') {
      const path = opts.modelPath.split('.')
      getter = function () {
        return path.reduce((acc, key) => (acc ? acc[key] : undefined), this)
      }.bind(ctx)
    } else {
      throw "gkCheckBeforeDate: provide either { getValue: fn } or { modelPath: 'a.b.c' }"
    }

    const unwatch = ctx.$watch(getter, (newVal) => {
      const selectedTs = toMidnightTs(newVal)
      const cutoffYmd = getCutoff()
      const cutoffTs = toMidnightTs(cutoffYmd)

      if (selectedTs == null || cutoffTs == null) return

      if (selectedTs <= cutoffTs) {
        // If callback was provided, call it. Otherwise do nothing.
        if (opts.callback) {
          const info = { selected: newVal, cutoff: cutoffYmd }

          // Same pattern as your confirm directive:
          // callback(callbackParams)
          // If you want date info too, set passContext: true
          if (opts.passContext) {
            opts.callback(opts.callbackParams, info)
          } else {
            opts.callback(opts.callbackParams)
          }
        } else {
          const t = opts.toast
          if (t && vnode.context.$bvToast) {
            vnode.context.$bvToast.toast(t.message || 'Date is before cutoff!', {
              title: t.title,
              variant: t.variant,
              solid: t.solid !== false,
              noAutoHide: true
            })
          }
        }
      }
    })

    el.__gkCheckBeforeDateUnwatch__ = unwatch
  },

  unbind(el) {
    if (el.__gkCheckBeforeDateUnwatch__) {
      el.__gkCheckBeforeDateUnwatch__()
      delete el.__gkCheckBeforeDateUnwatch__
    }
  }
})

function toMidnightTs(ymd) {
  if (!ymd) return null
  const ts = Date.parse(`${ymd}T00:00:00`)
  return Number.isNaN(ts) ? null : ts
}

function isFn(fn) {
  return fn && {}.toString.call(fn) === '[object Function]'
}

export default GkCheckBeforeDateDirective
